import { hideLoading } from "components/Loading"
import { showLoading } from "components/Loading"
import { useState } from "react"
import { toast } from "react-toastify"
import contratoService from "services/ContratoService"

const { default: CustomDropzone } = require("components/CustomDropzone")
const { Modal, ModalBody, Button } = require("reactstrap")

export default function ModalImportar({ idContrato, visible, onClosed, onUpdated }) {
  const [file, setFile] = useState()

  const handleChange = value => {
    setFile(value)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    showLoading()
    try {
      const res = await contratoService.importarItens(idContrato, file)
      hideLoading()
      if (res.success) {
        toast('Planilha importada com sucesso!')
        setFile()
        onUpdated && onUpdated()
        onClosed && onClosed()
      } else {
        toast("Erro ao importar planilha!")
      }
    } catch (ex) {
      hideLoading()
      console.log(ex)
      if (ex.response && ex.response.status == 400) {
        toast(ex.response.data.message)
        return
      }
      toast("Erro ao importar planilha!")
    }
  }

  return (
    <>
      <Modal isOpen={visible} onClosed={onClosed} size="lg">
        <ModalBody>
          <h2>Importar planilha de itens</h2>
          <hr />
          <form onSubmit={handleSubmit}>
            <CustomDropzone
              value={file}
              onChange={value => handleChange(value)}
              onRemove={() => handleChange(null)}
              edit={true}
            />
            <div className="text-right mt-4">
              <Button type="submit" color="primary">Importar</Button>
              <Button type="button" color="primary" outline onClick={onClosed}>Cancelar</Button>
            </div>
          </form>

        </ModalBody>
      </Modal>
    </>
  )
}